import IntegrationsService from "../services/IntegrationsService";

export default class IntegrationUtil {

    getNetlifySiteUrl(deployment, website) {
        // let netlifyIntegration = webase.managers.app.getIntegration('Netlify')
        //
        // if(netlifyIntegration) {
        //     let site = netlifyIntegration.metadata.sites.filter(site => (site.site_id === siteId))[0]
        //     return site.ssl_url
        // }

        if(website.custom_domain && !deployment.netlifySsl) {
            return 'https://' + deployment.name + '.netlify.app'
        }

        return deployment.ssl_url
    }

    getDnsInfo(siteId) {
        let request = {
            integration: {
                command: 'dns',
                site_id: siteId
            }
        }

        let netlifyIntegration = webase.managers.app.getIntegration('Netlify')
        let service = new IntegrationsService()

        service.executeCommand(netlifyIntegration.slug, request).then((response) => {
            console.log('dns retrieved')
            console.log(response)

        }).catch((message) => {
            console.log('error retrieving DNS')
            console.log(message)
        })
    }
}